export default __webpack_public_path__ + "images/4b8572fd6bc8567509f93e95d7651b42.png";